import api from '../api';

export type SchoolBookmarkType = 'material' | 'quiz' | 'assignment' | 'waecTopic' | 'jambTopic';

export interface SchoolBookmark {
  id: string;
  type: SchoolBookmarkType;
  title: string;
  subject: string;
  route: string;
  details?: string;
  savedAt: string;
}

export const readSchoolBookmarks = async (): Promise<SchoolBookmark[]> => {
  const response = await api.get('/school-bookmarks');
  return Array.isArray(response.data) ? response.data : [];
};

export const toggleSchoolBookmark = async (bookmark: SchoolBookmark): Promise<boolean> => {
  const response = await api.post('/school-bookmarks/toggle', bookmark);
  return Boolean(response.data?.bookmarked);
};

export const removeSchoolBookmark = async (id: string, type: SchoolBookmarkType): Promise<void> => {
  await api.delete(`/school-bookmarks/${encodeURIComponent(type)}/${encodeURIComponent(id)}`);
};
